import script from "./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue?vue&type=script&setup=true&lang=ts"

import "./App.vue?vue&type=style&index=0&id=2189793b&lang=less&scoped=true"

import exportComponent from "C:\\Users\\67434\\Desktop\\work\\jh\\fe-login\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2189793b"]])

export default __exports__